import {
  RESET,
  SET_HAS_FETCHED,
  SET_HAS_NEXT_PAGE,
  SET_IS_FETCHING_ORDERS,
  SET_IS_REPLACING_ORDERS,
  SET_OFFSET,
  SET_ORDERS,
  SET_SCHEDULE_STATE_COUNTS,
  SET_TOTAL,
} from "./orders.actionTypes";

const initialState = {
  isFetchingOrders: false,
  // Narrower than isFetchingOrders: true only for a fetch the user asked for that throws the whole
  // list away (a scheduling tab, a filter, a search). Background refreshes and "load more" leave it
  // false, so the rail is not covered by a loader the user did not ask for.
  isReplacingOrders: false,
  hasFetched: false,
  orders: [],
  pagination: {
    offset: 0,
    total: 0,
  },
  // Server-reported presence of a next page (Boolean(data.next)), not derived from
  // orders.length vs total - soft-deleted rows filtered client-side make that comparison unreliable.
  hasNextPage: false,
  // null until the first response carries them, so the tabs can tell "not loaded yet" from
  // "genuinely zero" and never flash a misleading 0.
  scheduleStateCounts: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_FETCHING_ORDERS: {
      return {
        ...state,
        isFetchingOrders: action.payload,
      };
    }

    case SET_IS_REPLACING_ORDERS: {
      return {
        ...state,
        isReplacingOrders: action.payload,
      };
    }

    case SET_ORDERS: {
      return {
        ...state,
        orders: action.payload,
      };
    }

    case SET_OFFSET: {
      return {
        ...state,
        pagination: { ...state.pagination, offset: action.payload },
      };
    }

    case SET_TOTAL: {
      return {
        ...state,
        pagination: { ...state.pagination, total: action.payload },
      };
    }

    case SET_HAS_FETCHED: {
      return { ...state, hasFetched: action.payload };
    }

    case SET_HAS_NEXT_PAGE: {
      return { ...state, hasNextPage: action.payload };
    }

    case SET_SCHEDULE_STATE_COUNTS: {
      return { ...state, scheduleStateCounts: action.payload };
    }

    case RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
